import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';
// constants
import routes from '../../../../constants/routes';

// hooks
import useFormulasCategoryCountQuery from '../../../../hooks/formulas/useFormulasCategoryCount';

// models
import { FormulaCardCategories } from '../../../../models/formula.model';

// components
import MessageCard from './MessagesCard';

const MessagesFrequencyAccount: FC<React.PropsWithChildren<unknown>> = () => {
    const history = useHistory();

    const { data: categoryCountData } = useFormulasCategoryCountQuery();

    const totalReviewMessages = Object.values(
        categoryCountData?.Review || {},
    ).reduce((acc: number, count) => acc + (count as number), 0);

    const totalScheduledMessages = Object.values(
        categoryCountData?.Scheduled || {},
    ).reduce((acc: number, count) => acc + (count as number), 0);

    const totalExpiredMessages = Object.values(
        categoryCountData?.Expired || {},
    ).reduce((acc: number, count) => acc + (count as number), 0);

    const totalArchivedMessages = Object.values(
        categoryCountData?.Archived || {},
    ).reduce((acc: number, count) => acc + (count as number), 0);

    const dataLengths: (number | undefined)[] = [
        totalReviewMessages,
        totalScheduledMessages,
        totalExpiredMessages,
        totalArchivedMessages,
    ];

    return (
        <Container>
            {FormulaCardCategories.map((category, index) => (
                <MessageCard
                    key={index}
                    heading={category.heading}
                    description={category.description}
                    handleViewMore={() =>
                        history.push(
                            routes.formulasCatalogWithTabs(category.category),
                        )
                    }
                    dataLength={dataLengths[index]}
                />
            ))}
        </Container>
    );
};

export default MessagesFrequencyAccount;

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(3),
});
